import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid2,
  IconButton,
  Paper,
  Switch,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ImportDicom from 'modules/Import/ImportDicom';
import ImportNonDicom from 'modules/Import/ImportNonDicom';

const OrderDetailImport: React.FC<any> = ({ dialogState, handleDialog, order }) => {
  const { t } = useTranslation('Orders');
  const [isDicom, setIsDicom] = useState<boolean>(false);

  const onCloseDialog = () => {
    handleDialog('import', false);
  };
  const toggleSwitchChange = (state: boolean) => {
    setIsDicom(state);
  };

  const tDicom = t('dicom');
  const tNonDicom = t('nondicom');
  const renderedSwitch = (
    <FormControlLabel
      control={
        <span>
          {isDicom ? tNonDicom : <strong>{tNonDicom}</strong>}
          <Switch
            checked={isDicom}
            onChange={(e, state) => {
              toggleSwitchChange(state);
            }}
          />
          {isDicom ? <strong>{tDicom}</strong> : tDicom}
        </span>
      }
      label=""
    />
  );

  return (
    <>
      <Typography component="div" id="scrollToForm">
        <Paper elevation={0}>
          <Dialog
            open={dialogState}
            onClose={onCloseDialog}
            aria-labelledby="form-dialog-title"
            maxWidth="xl"
            fullWidth={true}
          >
            <DialogTitle id="form-dialog-title" sx={{ pt: 0, pb: 0 }}>
              <Grid2
                container={true}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                {t('action.createStudy')}
                {renderedSwitch}
                <IconButton aria-label="close" onClick={onCloseDialog} size="large">
                  <CloseIcon />
                </IconButton>
              </Grid2>
            </DialogTitle>
            <DialogContent sx={{ p: 2, pt: 0 }} id="form-dialog-content">
              {isDicom ? (
                <ImportDicom order={order} onOrderCloseDialog={onCloseDialog} />
              ) : (
                <ImportNonDicom order={order} onOrderCloseDialog={onCloseDialog} />
              )}
            </DialogContent>
          </Dialog>
        </Paper>
      </Typography>
    </>
  );
};

export default OrderDetailImport;
